import { makeActionCreator } from '../../../utilities'
import { FillablePDFsConstants } from './fillablePDFs.constants'

export const saveFillablePDF = makeActionCreator(FillablePDFsConstants.SAVE_FILLABLE_PDF)
export const setCurrentStep = makeActionCreator(FillablePDFsConstants.SET_CURRENT_STEP, '__currentStep')
export const setAuthor = makeActionCreator(FillablePDFsConstants.SET_AUTHOR, 'author')
export const setCustomInputs = makeActionCreator(FillablePDFsConstants.SET_CUSTOM_INPUTS, 'customInputs')
export const resetFillablePDFsState = makeActionCreator(FillablePDFsConstants.RESET_FILLABLE_PDFS)
export const resetFillablePDFsOnChartExit = makeActionCreator(FillablePDFsConstants.RESET_FILLABLE_PDFS_ON_CHART_EXIT)
export const initializeFillablePDF = makeActionCreator(FillablePDFsConstants.INITIALIZE_FILLABLE_PDF)
export const deleteFillablePDF = makeActionCreator(FillablePDFsConstants.DELETE_FILLABLE_PDF, 'id')
export const setFillablePDFsList = makeActionCreator(FillablePDFsConstants.SET_FILLABLE_PDFS_LIST, 'fillablePDFsList')
export const setShowModal = makeActionCreator(FillablePDFsConstants.SET_SHOW_MODAL, 'showModal')
export const setPdfId = makeActionCreator(FillablePDFsConstants.SET_PDF_ID, 'id')
export const hydrateFillablePdfFromPcr = makeActionCreator(
  FillablePDFsConstants.HYDRATE_FILLABLE_PDF_FROM_PCR,
  'fillablePDF'
)
export const setFillablePDFsImportError = makeActionCreator(
  FillablePDFsConstants.SET_FILLABLE_PDFS_IMPORT_ERROR,
  'fillablePDFsImportError'
)
export const onFillablePDFsImportSuccess = makeActionCreator(FillablePDFsConstants.ON_FILLABLE_PDFS_IMPORT_SUCCESS)
export const setPdfName = makeActionCreator(FillablePDFsConstants.SET_PDF_NAME, 'name')
export const loadPdfFromDevice = makeActionCreator(FillablePDFsConstants.LOAD_PDF_FROM_DEVICE, 'pdfDocId')
export const setPdfUrl = makeActionCreator(FillablePDFsConstants.SET_PDF_URL, 'pdfUrl')
export const setPdfLoading = makeActionCreator(FillablePDFsConstants.SET_PDF_LOADING, 'pdfLoading')
export const setPdfError = makeActionCreator(FillablePDFsConstants.SET_PDF_ERROR, 'pdfError')
